import { createSelector } from 'reselect';

import { initialStateOnTemplate } from 'store/details/reducer';
import { ReduxStore } from 'store/types';

const selectDetailsState = (state: ReduxStore) => state.details;

export const selectDetailsOnTemplate = (templateId?: string) =>
    createSelector(selectDetailsState, (detailState) =>
        templateId && detailState.detailsByTemplateId[templateId]
            ? detailState.detailsByTemplateId[templateId]
            : initialStateOnTemplate,
    );

export const selectDetails = (templateId?: string) =>
    createSelector(
        selectDetailsOnTemplate(templateId),
        (detailsStateOnTemplate) =>
            detailsStateOnTemplate && detailsStateOnTemplate.details,
    );

export const selectCastAndCrew = (templateId?: string) =>
    createSelector(
        selectDetailsOnTemplate(templateId),
        (detailsStateOnTemplate) =>
            detailsStateOnTemplate && detailsStateOnTemplate.castAndCrew,
    );

export const selectDetailsLoading = (templateId?: string) =>
    createSelector(
        selectDetailsOnTemplate(templateId),
        (detailsStateOnTemplate) =>
            detailsStateOnTemplate && detailsStateOnTemplate.detailsLoading,
    );

export const selectDetailsError = (templateId?: string) =>
    createSelector(
        selectDetailsOnTemplate(templateId),
        (detailsStateOnTemplate) =>
            detailsStateOnTemplate && detailsStateOnTemplate.detailsError,
    );

export const selectDescriptionLoading = (templateId?: string) =>
    createSelector(
        selectDetailsOnTemplate(templateId),
        (detailsStateOnTemplate) =>
            detailsStateOnTemplate && detailsStateOnTemplate.descriptionLoading,
    );

export const selectDetailsRequestStatus = (templateId?: string) =>
    createSelector(
        selectDetailsOnTemplate(templateId),
        (detailsStateOnTemplate) =>
            detailsStateOnTemplate && detailsStateOnTemplate.detailsRequest,
    );

export const selectUnlockedId = createSelector(
    selectDetailsState,
    (detailsState) => detailsState.unlockedId,
);
